/**
 * Returns today's date as ISO string (YYYY-MM-DD).
 */
function getTodayISO() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Returns true if the given ISO date string is strictly before today.
 */
function isDateInPast(isoDate) {
  return isoDate < getTodayISO();
}

/**
 * Reads rawEta from localStorage with staleness check (5 min).
 */
function getLocalStorageEta() {
  var MAX_AGE_MS = 5 * 60 * 1000;
  try {
    var timestamp = parseInt(localStorage.getItem('rawEtaTimestamp') || '0', 10);
    var age = Date.now() - timestamp;
    if (age > MAX_AGE_MS) {
      return [];
    }
    return JSON.parse(localStorage.getItem('rawEta') || '[]');
  } catch (e) {
    return [];
  }
}

function formatDateWithSuffix(isoDate) {
  const [y, m, d] = isoDate.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d)); // avoid timezone shifts

  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getUTCMonth()];

  const suffix =
    day % 100 >= 11 && day % 100 <= 13
      ? 'th'
      : day % 10 === 1
        ? 'st'
        : day % 10 === 2
          ? 'nd'
          : day % 10 === 3
            ? 'rd'
            : 'th';

  return `${day}${suffix} ${month} ${year}`;
}

function getProductEtaDate(variantId, qty, metaData) {
  for (const variant of metaData) {
    if (variant.variant_id == variantId) {
      const ranges = variant.ranges;
      for (const r of ranges) {
        if (qty >= r.min && qty <= r.max) {
          return r.eta;
        }
      }
    }
  }
  return null;
}

let setCartAttribute = (Eta) => {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        ETA: Eta,
      },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      let etaText = document.querySelector('#cartEtaDisplay span');
      if (etaText) {
        etaText.innerText = data.attributes.ETA;
      }
      let etaDrawerText = document.querySelector('#cartDrawerEtaDisplay span');
      if (etaDrawerText) {
        etaDrawerText.innerText = data.attributes.ETA;
      }
    });
};

async function fetchFreshEtaFromProductPages(handles) {
  let freshEtaData = [];
  const fetchPromises = handles.map(async function (handle) {
    try {
      const response = await fetch('/products/' + handle);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const scriptTag = doc.getElementById('dispatch-eta-data');
      if (scriptTag) {
        let rawData = JSON.parse(scriptTag.textContent);
        if (typeof rawData === 'string') {
          rawData = JSON.parse(rawData);
        }
        for (const key in rawData) {
          if (rawData.hasOwnProperty(key)) {
            freshEtaData.push(rawData[key]);
          }
        }
      }
    } catch (e) {
      console.error('Error fetching ETA for', handle, e);
    }
  });

  await Promise.all(fetchPromises);
  return freshEtaData;
}

let updateEta = async () => {
  const cartItems = [];
  const totalDatesFound = [];
  
  try {
    const response = await fetch('/cart.js');
    const data = await response.json();
    data.items.forEach((item) => {
      cartItems.push({
        variant_id: item.variant_id,
        quantity: item.quantity,
        handle: item.handle
      });
    });

    // Step 1: Try localStorage (fast path)
    let etaData = getLocalStorageEta();

    // Step 2: Fetch fresh data for any items missing from localStorage
    var uniqueHandles = [];
    cartItems.forEach(function (item) {
      const isCached = etaData.some(function(cached) { return cached.variant_id == item.variant_id; });
      if (!isCached && item.handle && uniqueHandles.indexOf(item.handle) === -1) {
        uniqueHandles.push(item.handle);
      }
    });

    if (uniqueHandles.length > 0) {
      const freshData = await fetchFreshEtaFromProductPages(uniqueHandles);
      etaData = etaData.concat(freshData);
      
      // Save updated data to localStorage
      try {
        localStorage.setItem('rawEta', JSON.stringify(etaData));
        localStorage.setItem('rawEtaTimestamp', Date.now().toString());
      } catch (e) { }
    }

    cartItems.forEach((item) => {
      let datefound = getProductEtaDate(item.variant_id, item.quantity, etaData);
      if (datefound) {
        totalDatesFound.push(datefound);
      }
    });

    if (totalDatesFound.length > 0) {
      const latestDate = totalDatesFound.reduce(
        (max, curr) => (new Date(curr) > new Date(max) ? curr : max),
        totalDatesFound[0]
      );
      let formatedDate = formatDateWithSuffix(latestDate);
      setCartAttribute(formatedDate);
    } else {
      if (window.__enableCallUsForDetails) {
        setCartAttribute('Call Us For Details');
      }
    }
  } catch (err) {
    console.error('Error updating ETA:', err);
  }
};


//select all cart-product-info elements and get the data-selected-variant-id 
let getSelectedVariantId = () => {
  const cartProductInfoElements = document.querySelectorAll('.cart-product-info');
  cartProductInfoElements.forEach(element => {
    const selectedVariantId = element.dataset.selectedVariantId;
    updateCartItemsEta(selectedVariantId);
  });
};

const updateCartItemsEta = (selectedVariantId) => {
  let etaData = JSON.parse(localStorage.getItem('rawEta') || '[]');
  let found = false;
  etaData.forEach(item => {
    if (item.variant_id == selectedVariantId) {
      found = true;
      updateTargetCartItemEta(selectedVariantId, item.ranges);
    }
  });
  // No ETA data found for this variant at all — show "Call Us For Details"
  if (!found && window.__enableCallUsForDetails) {
    let targetDiv = document.querySelector(`[data-selected-variant-id="${selectedVariantId}"]`);
    if (targetDiv) {
      targetDiv.querySelector('.cart-item-eta-date-text').innerText = 'Est. Dispatch: Call Us For Details';
    }
  }
}

const updateTargetCartItemEta = (selectedVariantId, ranges) => {
  let targetDiv = document.querySelector(`[data-selected-variant-id="${selectedVariantId}"]`);
  let closestQtyInput = targetDiv.parentElement.querySelector('.cart-qty');
  let currentQty = parseInt(closestQtyInput.value);
  let etaDateText = cartItemEtaDate(selectedVariantId, currentQty, ranges);
  if (targetDiv && etaDateText) {
    // Guard: if date is in the past, show "Call Us For Details" instead
    if (isDateInPast(etaDateText)) {
      if (window.__enableCallUsForDetails) {
        console.warn('[cart-eta] Past date per-item ETA for variant', selectedVariantId, ':', etaDateText, '\u2014 showing Call Us For Details');
        targetDiv.querySelector('.cart-item-eta-date-text').innerText = 'Est. Dispatch: Call Us For Details';
        return;
      }
    }
    let convertedDate = formatDateWithSuffix(etaDateText);
    targetDiv.querySelector('.cart-item-eta-date-text').innerText = 'Est. Dispatch: ' + convertedDate;
  } else if (targetDiv && window.__enableCallUsForDetails) {
    // No ETA date found for this item (no matching range) — show "Call Us For Details"
    targetDiv.querySelector('.cart-item-eta-date-text').innerText = 'Est. Dispatch: Call Us For Details';
  }
}

const cartItemEtaDate = (selectedVariantId, currentQty, ranges) => {
  for (const r of ranges) {
    if (currentQty >= r.min && currentQty <= r.max) {
      return r.eta;
    }
  }
  return null;
}

let etaTimeout;
let getSelectedVariantIdTimeout;
window.addEventListener('cart:updated', function () {
  clearTimeout(etaTimeout);
  clearTimeout(getSelectedVariantIdTimeout);
  etaTimeout = setTimeout(async function () {
    await updateEta();
    getSelectedVariantId();
  }, 600);
});

window.addEventListener('cart-drawer:added', function () {
  clearTimeout(getSelectedVariantIdTimeout);
  getSelectedVariantIdTimeout = setTimeout(async function () {
    await updateEta();
    getSelectedVariantId();
  }, 1000);
});

window.addEventListener('cart-drawer:updated', async function () {
  await updateEta();
  getSelectedVariantId();
});

window.addEventListener('DOMContentLoaded', async function () {
  await updateEta();
  getSelectedVariantId();
});

